import { sendDataLayer } from "../services/datalayers";
declare global {
  interface Window {
      drupalSettings: any;
      CryptoJS: any;
  }
}
document.querySelector('.trnz-banner__btn')?.addEventListener('click', () => {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'Know Our Legacy',
        'interaction': 'true',
        'component_name': 'button_know_legacy',
        'element_text': 'Know Our Legacy',
    })
})

document.querySelector('.trnz-learn-more__btn')?.addEventListener('click', () => {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'Register and Know Our Legacy',
        'interaction': 'true',
        'component_name': 'button_register_know_legacy',
        'element_text': 'Register and Know Our Legacy',
    })
})

document.querySelector('.trnz-culture__btn')?.addEventListener('click', () => {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'Download Now',
        'interaction': 'true',
        'component_name': 'button_download_now',
        'element_text': 'Download Now',
    })
})

document.querySelector('.trnz-btn--share')?.addEventListener('click', () => {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'Share Podcast',
        'interaction': 'true',
        'component_name': 'button_share_podcast',
        'element_text': 'Share Podcast',
    })
})

Array.from(document.querySelectorAll('.trnz-podcast__subscribe'))?.forEach(item => {
    item.addEventListener('click', () => {
        sendDataLayer({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'button',
            'event_label': 'Subscribe for More Content',
            'interaction': 'true',
            'component_name': 'button_subscribe',
            'element_text': 'Subscribe',
        })
    })
})

document.querySelector('#tadaSwiper')?.addEventListener('click', (e: any) => {
    let clicked = e.target as HTMLElement;
    if (clicked.classList.contains('trnz-card-tada__btn')) {
        sendDataLayer({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Card',
            'event_label': `${clicked.dataset.product || ''}_product`,
            'interaction': 'true',
            'component_name': 'button_shop',
            'element_text': 'Shop'
        })
    }
})

document.querySelector('.trnz-tada__btn')?.addEventListener('click', () => {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'Go to TaDa',
        'interaction': 'true',
        'component_name': 'button_tada',
        'element_text': 'Tada'
    })
})


let wallpaperSwiper = document.querySelector('#wallpaperSwiper') as any;
document.querySelector('.trnz-wallpaper__btn')?.addEventListener('click', () => {
    if (wallpaperSwiper) {
        let { swiper } = wallpaperSwiper
        let currentImage = swiper.slides[swiper.activeIndex].querySelector('.trnz-wallpaper-card__image')

        sendDataLayer({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'button',
            'event_label': `${currentImage?.alt}_Download`,
            'interaction': 'true',
            'component_name': 'button_image_download',
            'element_text': 'Image Download',

        })
    }
})

document.querySelector('.trnz-social__btn')?.addEventListener('click', () => {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'See Results',
        'interaction': 'true',
        'component_name': 'button_see_results',
        'element_text': 'See Results',
    })
})

export function successRequest() {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'Send Passion Points Correct',
        'interaction': 'true',
        'component_name': 'button_success_passion_points',
        'element_text': 'Success Passion Points',
    })
}

export function failedRequest() {
    sendDataLayer({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'button',
        'event_label': 'Send Passion Points Incorrect',
        'interaction': 'true',
        'component_name': 'button_failed_passion_points',
        'element_text': 'Failed Passion Points',
    })
}

export function dataLayerTapit(){
  document.addEventListener("tapitLoad", function(evt: any) {
    const userData = evt.detail.user;
    const email = userData.email;
    const id = window.drupalSettings.user.uid;
    let hash = window.CryptoJS.SHA256(email).toString(window.CryptoJS.enc.Hex);        
    if(evt.detail.newUser == false){
        window.dataLayer.push({
            event: "login",
            medium: "Tapit",
            campaign: "aguila-trenzas-de-libertad",
            userID: hash,
        });
    }
    if(evt.detail.newUser == true){
        window.dataLayer.push({
            event: "Record",
            page: location.host + location.pathname,
            medium: "Tapit",
            campaign: "aguila-trenzas-de-libertad",
            userID: hash,
        });
    }
  })
}